import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setWhatsAppNumber } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [isGuest, setIsGuest] = useState(() => localStorage.getItem("uurs_guest") === "1");
  const [dark, setDark] = useState(() => localStorage.getItem("uurs_theme") === "dark");
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => { setSettings(r.data); setWhatsAppNumber(r.data.whatsapp_number); }).catch(() => {});
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("uurs_theme", dark ? "dark" : "light");
  }, [dark]);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setAuthLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setAuthLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const continueAsGuest = () => {
    localStorage.setItem("uurs_guest", "1");
    setIsGuest(true);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    setIsGuest(false);
    localStorage.removeItem("uurs_guest");
  };

  const value = {
    user, setUser, authLoading, checkAuth,
    isGuest, continueAsGuest, setIsGuest,
    dark, setDark, toggleDark: () => setDark((d) => !d),
    logout,
    settings, setSettings,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
